module.exports = __webpack_public_path__ + "img/icons8-mail-94.8a2314eb.png";